import { render, staticRenderFns } from "./AppointmentInformation.vue?vue&type=template&id=3840a772"
import script from "./AppointmentInformation.vue?vue&type=script&lang=ts"
export * from "./AppointmentInformation.vue?vue&type=script&lang=ts"
import style0 from "./AppointmentInformation.vue?vue&type=style&index=0&id=3840a772&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports